/**
 * When Age Rewind Core is added to cart, also add RH5.5 Hydrabond Primer
 * so the store's existing automatic offer can mark the primer free.
 *
 * Config is set in snippets/age-rewind-free-primer.liquid
 */
(function () {
  if (window.__parevaAgeRewindGiftInit) return;
  window.__parevaAgeRewindGiftInit = true;

  var origFetch = window.fetch;

  function getConfig() {
    return window.parevaAgeRewindGift || {};
  }

  function getTriggerIds() {
    return new Set((getConfig().triggerVariantIds || []).map(toNumber));
  }

  function getGiftId() {
    return toNumber(getConfig().giftVariantId);
  }

  function isGiftEnabled() {
    var cfg = getConfig();
    return !!(cfg.enabled && getGiftId() && getTriggerIds().size);
  }

  function isCartAddUrl(url) {
    if (!url) return false;
    try {
      var path = new URL(url, window.location.origin).pathname;
      return /\/cart\/add(?:\.js)?$/.test(path);
    } catch (e) {
      return /\/cart\/add(?:\.js)?(\?|$)/.test(String(url));
    }
  }

  function toNumber(value) {
    var n = Number(value);
    return Number.isFinite(n) ? n : 0;
  }

  function stripEmpty(item) {
    var next = { id: toNumber(item.id), quantity: toNumber(item.quantity) || 1 };
    if (item.selling_plan) next.selling_plan = item.selling_plan;
    if (item.properties && typeof item.properties === 'object') {
      next.properties = item.properties;
    }
    return next;
  }

  function normalizeJsonPayload(json) {
    if (!json || typeof json !== 'object') return null;
    if (Array.isArray(json.items) && json.items.length) {
      return {
        items: json.items.map(stripEmpty),
        sections: json.sections
      };
    }
    if (json.id) {
      return {
        items: [stripEmpty(json)],
        sections: json.sections
      };
    }
    return null;
  }

  function parseFormData(fd) {
    var id = fd.get('id');
    if (!id) return null;
    var item = {
      id: toNumber(id),
      quantity: toNumber(fd.get('quantity')) || 1
    };
    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;
    var properties = {};
    fd.forEach(function (value, key) {
      var match = String(key).match(/^properties\[([^\]]+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;
    var sections = fd.get('sections');
    return { items: [item], sections: sections || undefined };
  }

  function parseCartAddBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        return normalizeJsonPayload(JSON.parse(body));
      } catch (e) {
        return null;
      }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return parseFormData(body);
    }
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      return parseFormData(body);
    }
    return null;
  }

  function qtyForIds(items, idSet) {
    return items.reduce(function (total, item) {
      return idSet.has(toNumber(item.id)) ? total + (toNumber(item.quantity) || 1) : total;
    }, 0);
  }

  function copyHeaders(init, input) {
    var source = (init && init.headers) || (typeof Request !== 'undefined' && input instanceof Request ? input.headers : undefined);
    try {
      return new Headers(source || undefined);
    } catch (e) {
      return new Headers();
    }
  }

  async function readRequestBody(input, init) {
    if (init && init.body) return init.body;
    if (typeof Request !== 'undefined' && input instanceof Request) {
      try {
        var clone = input.clone();
        var contentType = (clone.headers.get('content-type') || '').toLowerCase();
        if (contentType.indexOf('application/json') !== -1) {
          return await clone.text();
        }
        return await clone.formData();
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  function getUrl(input) {
    if (typeof input === 'string') return input;
    if (input && input.url) return input.url;
    return '';
  }

  async function prepareArgs(input, init) {
    var url = getUrl(input);
    if (!isCartAddUrl(url)) return [input, init];

    var cfg = getConfig();
    if (!cfg.enabled || !cfg.giftVariantId) return [input, init];

    var triggerIds = new Set((cfg.triggerVariantIds || []).map(toNumber));
    var giftId = toNumber(cfg.giftVariantId);
    if (!triggerIds.size || !giftId) return [input, init];

    var body = await readRequestBody(input, init);
    var parsed = parseCartAddBody(body);
    if (!parsed || !parsed.items.length) return [input, init];

    var triggerQty = qtyForIds(parsed.items, triggerIds);
    var giftQty = qtyForIds(parsed.items, new Set([giftId]));
    var needGift = triggerQty - giftQty;
    if (needGift <= 0) return [input, init];

    var items = parsed.items.concat([{ id: giftId, quantity: needGift }]);
    var payload = { items: items };
    if (parsed.sections) payload.sections = parsed.sections;

    var headers = copyHeaders(init, input);
    headers.set('Content-Type', 'application/json');
    if (!headers.has('Accept')) headers.set('Accept', 'application/json');

    var nextInit = Object.assign({}, init || {}, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload)
    });

    return [url, nextInit];
  }

  async function normalizeAddResponse(response, url) {
    if (!isCartAddUrl(url) || !response || !response.ok) return response;

    var contentType = (response.headers.get('content-type') || '').toLowerCase();
    if (contentType.indexOf('json') === -1 && contentType.indexOf('javascript') === -1) {
      return response;
    }

    var data;
    try {
      data = await response.clone().json();
    } catch (e) {
      return response;
    }

    if (!data || data.variant_id || !Array.isArray(data.items) || !data.items.length) {
      return response;
    }

    var triggerIds = new Set((getConfig().triggerVariantIds || []).map(toNumber));
    var primary =
      data.items.find(function (item) {
        return triggerIds.has(toNumber(item.variant_id || item.id));
      }) || data.items[0];

    var merged = Object.assign({}, primary, {
      items: data.items,
      sections: data.sections
    });

    return new Response(JSON.stringify(merged), {
      status: response.status,
      statusText: response.statusText,
      headers: { 'Content-Type': 'application/json' }
    });
  }

  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = getUrl(input);
      if (!isCartAddUrl(url)) {
        return origFetch.call(this, input, init);
      }

      return prepareArgs(input, init).then(function (args) {
        return origFetch.apply(this, args).then(function (response) {
          return normalizeAddResponse(response, url);
        });
      }.bind(this));
    };
  }

  function parseCartPairs(pathname) {
    var match = String(pathname).match(/^(.*\/cart\/)(\d+:\d+(?:,\d+:\d+)*)\/?$/);
    if (!match) return null;
    return {
      prefix: match[1],
      pairs: match[2].split(',').map(function (part) {
        var bits = part.split(':');
        return { id: toNumber(bits[0]), qty: toNumber(bits[1]) || 1 };
      })
    };
  }

  function augmentCartPermalink(url) {
    if (!url || !isGiftEnabled()) return url;
    var parsed;
    try {
      parsed = new URL(url, window.location.origin);
    } catch (e) {
      return url;
    }

    var cart = parseCartPairs(parsed.pathname);
    if (!cart) return url;

    var triggerIds = getTriggerIds();
    var giftId = getGiftId();
    var triggerQty = cart.pairs.reduce(function (total, pair) {
      return triggerIds.has(pair.id) ? total + pair.qty : total;
    }, 0);
    var giftQty = cart.pairs.reduce(function (total, pair) {
      return pair.id === giftId ? total + pair.qty : total;
    }, 0);
    var needGift = triggerQty - giftQty;
    if (needGift <= 0) return url;

    cart.pairs.push({ id: giftId, qty: needGift });
    parsed.pathname =
      cart.prefix +
      cart.pairs
        .map(function (pair) {
          return pair.id + ':' + pair.qty;
        })
        .join(',');

    if (!/^https?:/i.test(url)) {
      return parsed.pathname + parsed.search + parsed.hash;
    }
    return parsed.toString();
  }

  function permalinkForBuyNow(button) {
    var form =
      (button && button.closest && button.closest('form')) ||
      document.querySelector('[data-product-form] form') ||
      document.querySelector('product-form form');
    var url = (button && (button.getAttribute('data-url') || button.dataset.url)) || '';

    if (form) {
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      var variantId = toNumber(idInput && idInput.value);
      var quantity = toNumber(qtyInput && qtyInput.value) || 1;
      if (variantId && getTriggerIds().has(variantId)) {
        url = '/cart/' + variantId + ':' + quantity;
      }
    }

    return augmentCartPermalink(url);
  }

  function syncBuyNowUrls() {
    document.querySelectorAll('[data-quick-buy-pdp]').forEach(function (button) {
      var next = permalinkForBuyNow(button);
      if (next) button.setAttribute('data-url', next);
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('[data-quick-buy-pdp]');
      if (!button || !isGiftEnabled()) return;

      var next = permalinkForBuyNow(button);
      if (!next) return;

      var cart;
      try {
        cart = parseCartPairs(new URL(next, window.location.origin).pathname);
      } catch (e) {
        return;
      }
      if (!cart) return;

      var hasTrigger = cart.pairs.some(function (pair) {
        return getTriggerIds().has(pair.id);
      });
      var hasGift = cart.pairs.some(function (pair) {
        return pair.id === getGiftId();
      });
      if (!hasTrigger || !hasGift) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      button.setAttribute('data-url', next);
      window.location.href = next;
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncBuyNowUrls);
  } else {
    syncBuyNowUrls();
  }
  window.addEventListener('Variant:Changed', function () {
    setTimeout(syncBuyNowUrls, 0);
  });
})();
